// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.circle[data-v-ffc17b5c] \n{\n  font-size: x-large;\n  color: lightgray;\n  vertical-align: middle;\n}\n.star.active[data-v-ffc17b5c]\n{\n  color: green;\n}\ntd[data-v-ffc17b5c]\n{\n  vertical-align: middle !important;\n}\ntd.r[data-v-ffc17b5c]\n{\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
